import React, { useEffect, useState } from "react";
import { Flex, Link, Text, Heading, Box, Container, Separator, Card, Avatar, Badge } from "@radix-ui/themes";


interface ServerConfig {
  mode: string;
  version: string;
}

const HomeContents: React.FC<ServerConfig> = ({ mode, version }) => {
  return (
    <Box>
      <Container size="3" px="6" py="9">
        <Heading weight="bold" size="9">Live Football On TV.</Heading>
        <Flex direction="column" gap="2" py="4" justify="between">
          <Flex direction="row">
            <Text size="2">Mode: </Text> 	<Badge color="orange">{mode}</Badge>
          </Flex>
          <Flex direction="row">
            <Text size="2">Version: </Text> 	<Badge color="green">{version}</Badge>
          </Flex>
        </Flex>

        <Box maxWidth="240px" py="4">
          <Separator orientation="horizontal" size="4" />
          <Card asChild mt="4">
            <a href="https://milla.is/" style={{ textDecoration: "none", color: "inherit" }}>
              <Flex gap="3" align="center">
                <Avatar
                  size="3"
                  src="./../images/profile.jpg"
                  radius="full"
                  fallback="PM"
                />
                <Box>
                  <Text as="div" size="2" weight="bold">
                    Patrick Millais
                  </Text>
                  <Text as="div" size="2" color="gray">
                    Copyright 2026
                  </Text>
                </Box>
              </Flex>
            </a>
          </Card>
        </Box>

        <Text as="div" size="2" color="gray">
          In partnership with <Link href="https://www.live-footballontv.com/">Live Football On TV</Link>
        </Text>

      </Container>
    </Box>
  );
};



const Home: React.FC = () => {

  // State to hold the fetched config data
  const [serverConfig, setConfig] = useState<ServerConfig | null>(null);
  // State to track loading status
  const [loading, setLoading] = useState<boolean>(true);
  // State to track any errors during fetch
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch('/config');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data: ServerConfig = await response.json();
        setConfig(data);
      } catch (err) {
        if (err instanceof Error) {
          setError(err.message);
        } else {
          setError('An unknown error occurred');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchConfig(); // Call the fetch function when the component mounts
  }, []); // Empty dependency array means this effect runs ONLY ONCE when the component mounts

  if (loading) {
    return HomeContents({ mode: "Loading...", version: "Loading..." });
  }

  if ((error) || !serverConfig) {
    return HomeContents({ mode: ":(", version: ":(" });
  }

  return HomeContents({ mode: serverConfig.mode, version: serverConfig.version });
};

export default Home;